import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import { NavBar } from "../Navbar/NavBar";
import "../../Assets/CSS/bulkorder.css";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import EditIcon from "../../Assets/Images/OMS/edit.svg";
import EditOc from "./EditOc";
import PlaceOrderInventory from "./PlaceOrderInventory";
import axios from "axios";
import Loader from "../Loader";
import moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ClipLoader } from "react-spinners";
import { Box, Button, Collapse, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ExpandableRow(props) {
  const { product, rows, handleOpen, handlePlaceOrder } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <ToastContainer />

      <TableRow sx={{ bgcolor: open ? "#e2e8f0" : "#f3f4f6" }}>
        <TableCell className="px-0 py-3">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
          {product}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={6} className="p-0">
          <Collapse className="p-0" in={open} timeout="auto" unmountOnExit>
            <Box className="">
              {open && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                  {rows?.map((row) => {
                    return (
                      <div className=" p-3 pt-3 shadow-lg rounded-md">
                        <div></div>
                        <div className="flex">
                          <div className="">
                            {" "}
                            <img
                              src={row?.product?.product_images?.[0]}
                              alt="No Img"
                              className="w-20"
                            />
                          </div>
                          <div className="ms-3 leading-loose tracking-wide">
                            <p className="fw-bolder p-0 m-0">
                              {row?.product?.product_name
                                ? row?.product?.product_name
                                : "-"}
                            </p>
                            <p className="flex justify-start">
                              Rs.{" "}
                              {row?.product?.selling_price
                                ? row?.product?.selling_price
                                : "--/"}
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-start tracking-wide ">
                          <span className="text-muted">
                            Available Quantity:{" "}
                          </span>{" "}
                          <span className="ps-1">
                            {row?.available_quantity
                              ? row?.available_quantity
                              : 0}{" "}
                            bags
                          </span>
                        </div>
                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="text-muted">
                            Primary Sales Order:
                          </span>{" "}
                          <span className="ps-1">
                            {row?.primary_order_buyer
                              ? row?.primary_order_buyer
                              : 0}
                          </span>
                        </div>
                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="text-muted">
                            Secondary Sales Order:
                          </span>{" "}
                          <span className="ps-1">----- </span>
                        </div>
                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="text-muted">Supplier Name:</span>{" "}
                          <span className="ps-1">
                            {row?.supplier?.first_name
                              ? row?.supplier?.first_name
                              : ""}{" "}
                            {row?.supplier?.last_name
                              ? row?.supplier?.last_name
                              : ""}
                          </span>
                        </div>
                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="text-muted">
                            Supplier Location:{" "}
                          </span>{" "}
                          <span className="ps-1">
                            {row?.supplier?.state ? row?.supplier?.state : ""}
                          </span>
                        </div>
                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="text-muted">Cost Price: </span>{" "}
                          <span className="ps-1">
                            {row?.product?.buying_price || "NA"}
                          </span>
                        </div>

                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="">Quality Parameters </span>{" "}
                          <span className="ps-2 mt-2">
                            <img
                              src={EditIcon}
                              alt=""
                              role="button"
                              onClick={() => handleOpen(row?.id)}
                            />
                          </span>
                        </div>
                        <div className="row mx-0 p-0 m-0 border-2">
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6 ">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Broken Grains:</span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.broken_grains || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Damaged Grains</span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.damaged_grains || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose ">
                              <span className="text-muted">
                                Discolored Grains:
                              </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.discoloured_grains ||
                                  "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">
                                Falling Numbers:{" "}
                              </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.falling_numbers || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">FM: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.fm || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Gluten: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.gluten || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Grain Color: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.grain_colour || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Grain Length: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.grain_length || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">
                                Grain Thickness:{" "}
                              </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.grain_thickness || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Grain Width: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.grain_width || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Hardness: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.hardness || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">HM: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.hm || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">
                                Insects Fungi:{" "}
                              </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.insects_fungi || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Kernel Size: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.kernel_size || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Moisture: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.moisture || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Odour: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.odour || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Oil Content: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.oil_content || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Other Grains: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.other_grains || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">
                                Protein Content:
                              </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.protein_content || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Shrivelled: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.shrivelled || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Shruken: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.shruken || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6 col-6">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">
                                Starch Content:
                              </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.starch_content || "NA"}
                              </span>
                            </div>
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Variety: </span>{" "}
                              <span className="ps-2 ">
                                {row?.current_qp?.[0]?.variety || "NA"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-start leading-loose tracking-wide">
                          <span className="">Warehouse Details </span>{" "}
                        </div>
                        <div className="row mx-0 p-0 m-0">
                          <div className="col col-md-6 col-sm-6 col-lg-6  col-6 p-0">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Rent:</span>{" "}
                              <span className="ps-1">
                                {row?.wearhouse_rent || "NA"}
                              </span>
                            </div>
                          </div>
                          <div className="col col-md-6 col-sm-6 col-lg-6  col-6 p-0">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">
                                Date of storage:{" "}
                              </span>{" "}
                              <span className="ps-1">
                                {row?.warehouse_in_time
                                  ? moment(row?.warehouse_in_time).format(
                                      "DD-MM-YYYY HH:mm:ss"
                                    )
                                  : "NA"}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row mx-0 p-0 m-0">
                          <div className="col col-md-12 col-sm-12 col-lg-12  col-12 p-0">
                            <div className="flex justify-start leading-loose tracking-wide">
                              <span className="text-muted">Location:</span>{" "}
                              <span className="ps-1">
                                {row?.warehouse_location || "NA"}
                              </span>
                            </div>
                          </div>
                          <Button
                            variant="contained"
                            onClick={() => handlePlaceOrder(row?.id)}
                          >
                            Place Order
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function Inventory() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedInventoryId, setSelectedInventoryId] = useState(null);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [selectedQualityParameter, setSelectedQualityParameter] = useState({});

  const handleOpen = (inventoryId) => {
    setSelectedInventoryId(inventoryId);
    const inventory = Object.values(data)
      .flat()
      .filter((each) => each.id === inventoryId);
    setSelectedQualityParameter(inventory?.[0]?.current_qp?.[0]);
    setOpen(true);
  };

  const handlePlaceOrder = (inventoryId) => {
    const inventory = Object.values(data)
      .flat()
      .find((each) => each.id === inventoryId);
    if (inventory) {
      setSelectedInventory(inventory);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedInventoryId(null);
    setSelectedQualityParameter({});
  };

  const handleClosePlaceOrder = () => {
    setSelectedInventory(null);
  };

  //  Get Inventory Data

  const getData = () => {
    axios
      .get(`/api/oms/products?limit=1000`)
      .then((response) => {
        setData(
          Object.groupBy(
            response?.data?.products?.rows,
            ({ product }) => product.product_name
          )
        );
        setLoading(false);
      })
      .catch((error) => {
        setData({});
        console.log(error);
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="flex">
      {/* <Sidebar /> */}
      <div className="mt-3 ml-8 builk-main " >
        <Loader loading={loading} />
        {/* <NavBar /> */}
        <div className=" ms-0 ps-0 mt-2 m-4 pt-4  ml-8">
          <div className="flex justify-start">
            <span
              role="button"
              className="fw-bolder"
              onClick={() => navigate("/oms")}
            >
              OMS
            </span>{" "}
            <span role="button" className="fw-bolder">
              {" "}
              <ChevronRightIcon /> Inventory
            </span>
          </div>
          <h4 className="flex justify-start mt-2">Inventory</h4>
          <div className="  mx-0 p-0 mt-4">
            {/* Item 1 */}
            <TableContainer component={Paper} className="overflow-x-scroll">
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead className="" style={{ backgroundColor: "red" }}>
                  <TableRow className="p-2">
                    <TableCell align="center" className="">
                      Products
                    </TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <>
                    <TableCell>
                      <ClipLoader />
                    </TableCell>
                  </>
                ) : (
                  <TableBody>
                    {Object.keys(data)?.length === 0 ? (
                      <>
                        <TableCell align="center">No Data Found</TableCell>
                      </>
                    ) : (
                      Object.keys(data)?.map((row, index) => (
                        <ExpandableRow
                          product={row}
                          rows={data[row]}
                          handleOpen={handleOpen}
                          handlePlaceOrder={handlePlaceOrder}
                        />
                      ))
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      {selectedInventory && (
        <PlaceOrderInventory
          selectedInventory={selectedInventory}
          handleClose={handleClosePlaceOrder}
          getData={getData}
          setLoading={setLoading}
          inventoryId={selectedInventoryId}
          selectedQualityParameter={selectedQualityParameter}
        />
      )}
      <EditOc
        open={open}
        handleClose={handleClose}
        getData={getData}
        setLoading={setLoading}
        inventoryId={selectedInventoryId}
        selectedQualityParameter={selectedQualityParameter}
      />
    </div>
  );
}

export default Inventory;
